
define('act.count.down.v2',function(require,exports,module){
 var countDown=function(){
        this.timeInterVal=null;
        this.init=function(timeObj,callback){
            this.curTime=timeObj.serverTime||Date.parse(new Date());
            this.leftTime=timeObj.startTime.indexOf && timeObj.startTime.indexOf('-')>=0?(Date.parse((timeObj.startTime).replace(/-/g,'/')) - this.curTime):Date.parse(timeObj.startTime) - this.curTime;
            var self=this;
            this.updateTime(callback);

            if(self.timeInterVal){
                clearInterval(self.timeInterVal);
            }
            if(timeObj.index){
                self.index = timeObj.index;
            }
            this.timeInterVal = setInterval(function(){
                self.updateTime(callback);
            }, 1000);
        };

        // 计算下一秒时间，执行 callback
        this.updateTime = function(callback){
            var self = this;
            var t = self.getRemainTime();
            callback(t);
        };

        // 下一秒剩余时间的时间对象
        this.getRemainTime = function(){
            var self = this;
            this.leftTime = this.leftTime - 1000;
            var t = this.leftTime;
            var seconds = Math.floor( (t/1000) % 60 );
            var minutes = Math.floor( (t/1000/60) % 60 );
            var hours = Math.floor( (t/(1000*60*60)) % 24 );
            var days = Math.floor( t/(1000*60*60*24) );
            return {
                'obj': self,
                'total': t,
                'days': days,
                'hours': ('0' + hours).slice(-2),
                'minutes': ('0' + minutes).slice(-2),
                'seconds': ('0' + seconds).slice(-2)
            };
        } ;
    };

    exports.countDown = function(){
         return new countDown();
    }  
});



// WEBPACK FOOTER //
// ./../common/js/act.count.down.v2.js